export default __webpack_public_path__ + "static/media/img-cyln-half-face.a5afeaa1.png";